import './AppliedFacets.scss';
import React from 'react';

const AppliedFacets = () => {
    return (
        <div className="applied-facets small-screen-padding hide-scrollbars">
            {/* TODO: applied facets clear buttons rendered after loading facets */}
        </div>
    );
}

export default AppliedFacets;